module.exports = __webpack_public_path__ + "images/competitive-retail-tracker-95913024.svg";